import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import resumeRepositoryService from "../services/resumeRepositoryService";
import { RESUME_QUERY_KEYS } from "./useResumeSearch";

const useTalentPools = (params = {}) => {
  const queryClient = useQueryClient();

  const listQuery = useQuery({
    queryKey: [RESUME_QUERY_KEYS.talentPools, params],
    queryFn: () => resumeRepositoryService.listTalentPools(params),
  });

  const createPoolMutation = useMutation({
    mutationFn: (payload) => resumeRepositoryService.createTalentPool(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [RESUME_QUERY_KEYS.talentPools],
      });
    },
  });

  const addCandidatesMutation = useMutation({
    mutationFn: ({ poolId, payload }) =>
      resumeRepositoryService.addCandidatesToPool(poolId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [RESUME_QUERY_KEYS.talentPools],
      });
    },
  });

  const removeCandidatesMutation = useMutation({
    mutationFn: ({ poolId, payload }) =>
      resumeRepositoryService.removeCandidatesFromPool(poolId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [RESUME_QUERY_KEYS.talentPools],
      });
    },
  });

  return {
    ...listQuery,
    createPoolMutation,
    addCandidatesMutation,
    removeCandidatesMutation,
  };
};

export default useTalentPools;
